module.exports = __webpack_public_path__ + "img/404切图@2x.b135d9dd.png";